import React, { useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Toggle from 'react-toggle';

import AboutAiRequestsModal from './AboutAiRequestsModal';

const AiAssistantMenuBlock = ({ open }) => {
	const dispatch = useDispatch();
	const aiAssistantEnabled = useSelector(state => state.dashboardData.aiAssistantEnabled);
	const [showAboutAiRequestsModal, setShowAboutAiRequestsModal] = useState(false);
	const resetDate = moment().add(1, 'month').startOf('month').locale('en').format('MMM D, YYYY');

	const openAboutModal = () => setShowAboutAiRequestsModal(true);
	const closeAboutModal = () => setShowAboutAiRequestsModal(false);
	const handleToggle = ({ target }) => {
		dispatch({ type: 'SET_AI_ASSISTANT_ENABLED', payload: target.checked });
	}
	const handleAboutKeyDown = ({ key }) => {
		if (key === 'Enter' || key === ' ') {
			openAboutModal();
		}
	}

	return (
		<div className={`ai-assistant-menu-block ${aiAssistantEnabled ? 'is-enabled' : 'is-disabled'}`}>
			<div className="ai-assistant-header">
				<div className="ai-assistant-title">
					<span className="ai-assistant-sparkle">{String.fromCharCode(10022)}</span>
					<span>AI Assistant</span>
					<span className="ai-assistant-beta">Beta</span>
				</div>
				<label className="ai-assistant-toggle">
					<Toggle
						checked={aiAssistantEnabled}
						icons={false}
						aria-label="AI Assistant"
						onChange={handleToggle}
					/>
					{open && <span>{aiAssistantEnabled ? 'On' : 'Off'}</span>}
				</label>
			</div>
			{open && aiAssistantEnabled && (
				<div className="ai-assistant-cards">
					<div className="ai-assistant-card ai-requests-card">
						<div className="ai-card-icon requests-icon">
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" focusable="false" role="presentation">
								<rect x="3" y="6" width="24" height="17" rx="3" stroke="currentColor" strokeWidth="2" />
								<path d="M8 12h14M8 17h8M22 24l2 4 2-4 4-2-4-2-2-4-2 4-4 2 4 2z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
							</svg>
						</div>
						<div className="ai-card-content">
							<div className="ai-card-title">AI Requests (This Month)</div>
							<div className="ai-card-stat">5 / 34</div>
							<div className="ai-progress">
								<span style={{ width: '15%' }} />
							</div>
							<div className="ai-card-note">Resets on {resetDate}</div>
						</div>
					</div>
					<div
						className="ai-assistant-card ai-about-card"
						role="button"
						tabIndex={0}
						onClick={openAboutModal}
						onKeyDown={handleAboutKeyDown}
					>
						<div className="ai-card-icon about-icon">
							<svg width="28" height="28" viewBox="0 0 28 28" fill="none" focusable="false" role="presentation">
								<path d="M14 25v-4M10.5 19.5h7M8 12.5a6 6 0 1 1 12 0c0 2.2-1.2 3.6-2.4 4.6-.7.6-1.1 1.2-1.3 1.9h-4.6c-.2-.7-.6-1.3-1.3-1.9C9.2 16.1 8 14.7 8 12.5z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div>
						<div className="ai-card-content">
							<div className="ai-card-title">About AI Requests</div>
							<div className="ai-card-text">Used when you generate or regenerate AI summaries.</div>
						</div>
						<b className="ai-card-chevron">&rsaquo;</b>
					</div>
				</div>
			)}

			{showAboutAiRequestsModal &&
				<AboutAiRequestsModal onHide={closeAboutModal} resetDate={resetDate} />
			}
		</div>
	)
}

export default AiAssistantMenuBlock;
